module.exports = __webpack_public_path__ + "img/plant_0_mobile_small.dfa5d87e.webp";